document.addEventListener("DOMContentLoaded", function () {
  const logoutLinks = document.querySelectorAll('a[href*="/account/logout"]');

  logoutLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      fetch("/cart/clear.js", {
        method: "POST",
      }).then(() => {
        console.log("🛒 Cart cleared");
        window.location.href = link.href;
      });
    });
  });
});
